<template>
  <permission-gate
    v-slot="{ canEdit }"
    moduleKey="propuestas"
  >
    <MainBreadcrumb
      :items="items"
      showBackButton
    ></MainBreadcrumb>
    <MainButtonsBar :align="'space-between'">
      <template #left>
        <CustomTitle>Listado de propuestas comerciales</CustomTitle>
      </template>
      <template #right>
        <el-tooltip
          v-if="!canEdit"
          content="El usuario no posee permisos de edición"
          placement="top"
        >
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            disabled
          >
            Nueva propuesta
          </el-button>
        </el-tooltip>

        <template v-else>
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            @click="router.push({ path: '/page/proposals/edit' })"
            >Nueva propuesta</el-button
          >
        </template>
      </template>
    </MainButtonsBar>
    <ProposalsFilters />
    <CustomTable
      :requestApi="findAllProposalsHTTP"
      :pathDetail="'/page/proposals/detail'"
      :pathEdit="'/page/proposals/edit'"
      :paramId="'Codigo'"
      :data="proposals"
      :columns="columns"
      :showDetailButton="false"
    >
      <template #custom-actions="{ row }">
        <el-button
          v-if="row.Codigo > 0"
          :icon="IconPrinter"
          @click.prevent="printProposal(row)"
        ></el-button>
      </template>
    </CustomTable>
  </permission-gate>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useProposalsStore } from '../proposals_store';
import { useAuthStore } from '../../auth/auth_store';
import ProposalsFilters from './proposals_filters.vue';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import { usePrint } from '@/shared/composables/print';
import PermissionGate from '@/shared/components/permission_gate.vue';
import IconAdd from '~icons/mdi/add';
import IconPrinter from '~icons/mdi/printer';
const router = useRouter();

const proposalsStore = useProposalsStore();
const { proposals } = storeToRefs(proposalsStore);
const { firstRequest, resetFilters, resetProposal, findAllProposalsHTTP } = proposalsStore;
// local state
const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];

const columns = [
  { field: 'Codigo', label: 'ID', width: 100, sortable: true, isVisible: true },
  {
    field: 'FechaCreacion',
    label: 'Fecha',
    width: 120,
    sortable: true,
    isVisible: true,
    isDate: true,
  },
  {
    field: 'Cotizaciones',
    label: 'Cód. Cotizaciones',
    width: 180,
    sortable: false,
    isVisible: true,
  },
  { field: 'DescripcionCliente', label: 'Cliente', width: 280, sortable: true, isVisible: true },
  { field: 'Producto', label: 'Producto', width: 450, sortable: true, isVisible: true },
];

const printProposal = async (propuesta) => {
  usePrint().printReport('propuesta_comercial', {
    Codigo: propuesta.Codigo,
  });
};

onBeforeMount(async () => {
  resetFilters();
  resetProposal();

  const auth = useAuthStore();

  if (auth.hasRole(1)) {
    proposalsStore.setRoleFilters({ CodigoVendedor: auth.usuario().Codigo });
  } else {
    proposalsStore.setRoleFilters({});
  }
  firstRequest();
});
</script>

<style scoped></style>
